import React from 'react';
import styled, { css } from 'styled-components';
import { applyStyleModifiers, decorateModifiersConfig } from '../../../lib/style-modifiers/style-modifiers';

import { CaesarsRewards, TickSmall, WilliamHillRewards } from '../../../assets/icons';
import { useSelector } from 'react-redux';
import { IStoreState } from '../../../store/types';
import { robotoFonts } from '../../../components/typography';

export type Modifier = keyof typeof modifiers;

export type Props = {
  children: React.ReactNode;
  modifiers?: Modifier | Modifier[];
  disabled?: boolean;
  onClick?: () => void;
};

export default function CashOutButton({ children, ...restProps }: Props) {
  return <Wrapper {...restProps}>{children}</Wrapper>;
}

const modifiers = decorateModifiersConfig({
  primary: ({ theme }) => css`
    color: ${theme.colors.black};
    background-color: ${theme.components.cashOut.buttons.primary.backgroundColor};
    &:disabled {
      color: ${theme.colors.white};
      background-color: ${theme.components.cashOut.buttons.primary.disabled.backgroundColor};
    }
  `,
  secondary: ({ theme }) => css`
    color: ${theme.components.cashOut.buttons.secondary.color};
    background-color: ${theme.components.cashOut.buttons.secondary.backgroundColor};
  `,
  fit: () => css`
    padding: 0 3rem;
    width: auto;
  `,
  slim: () => css`
    height: 4.4rem;
    font-size: ${robotoFonts.xl};
  `
});

const Wrapper = styled.button`
  align-items: center;
  border: 0;
  border-radius: ${({ theme }) => theme.borderRadius.xxxlarge};
  font-size: ${robotoFonts['3xl']};
  font-weight: 600;
  display: flex;
  justify-content: center;
  height: 4.8rem;
  width: 46rem;
  ${applyStyleModifiers(modifiers)};
`;

export function RewardsNotAvailableLabel() {
  const playerCardOperator = useSelector(({ device }: ReturnType<IStoreState>) => device?.info?.playerCardOperator);
  return <>Early Cashout Only Available With {translateCardOperator(playerCardOperator)}</>;
}

export function CompleteLabel() {
  return (
    <>
      Done
      <TickSmall style={{ marginLeft: '1rem' }} />
    </>
  );
}

function translateCardOperator(playerCardOperator?: string) {
  if (playerCardOperator === 'CAESARS') {
    return <CaesarsRewards style={{ marginLeft: '1rem' }} />;
  }
  if (playerCardOperator === 'WILLIAM_HILL') {
    return <WilliamHillRewards style={{ marginLeft: '1rem' }} />;
  }

  return 'a Rewards card';
}
